// extracted by mini-css-extract-plugin
export default {"accordion":"Price_accordion__e1Hdw","priceInput":"Price_priceInput__G476l"};